export const enum UserAnonymitySettingsEnum {
  ANONYMOUS = 'anonymous',
  CHOOSE_DEFAULT_ANONYMOUS = 'choose_default_anonymous',
  CHOOSE_DEFAULT_PUBLIC = 'choose_default_public',
  PUBLIC = 'public',
}
